import React, { useState, useEffect } from "react"
import Select from "react-select"
import Modal from "react-modal"

import { SingleOption, customStyles, parseBudat, getLocaleStringNumber } from "../../utils/utils.js"
import { showGreyBackground, hideGreyBackground, scrollTo } from "../../utils/windows.js"
import { getAlertIconVentas } from "../../utils/get"
import { customModalStyles } from "../../utils/styles"

import closeIcon from "../../../assets/img/cross-icon.svg"
import chevronRight from "../../../assets/img/chevron-right.svg"

const selector = "litros"
const styles = customModalStyles(20)
styles.content.padding = 0

const types = [
  {key: "controlador", label: "Controlador"},
  {key: "documentados", label: "Documentados"},
  {key: "confirmados", label: "Confirmados"},
  {key: "documentados_menos_controlador", label: "Documentados - Controlador"},
  {key: "confirmados_menos_documentados", label: "Confirmados - Documentados"}
]

export const VentasMobile = ({ ventas }) => {
  const [editingMaterial, setEditingMaterial] = useState()

  const closeModal = () => {
    hideGreyBackground()
    setEditingMaterial()
  }

  const showDetalle = (material) => {
    showGreyBackground()
    scrollTo(0, 0)
    setEditingMaterial(material)
  }

  return (
    <div className={`hide-desktop ${editingMaterial?"min-height-800": ""}`}>
      <div className="big-subtitle">
        Ventas
        <hr className="title-separator-line" />
      </div>
      <table className="responsive-table separated-th-table">
        <thead>
          <tr>
            <th>
              <div className="th-data">Material</div>
            </th>
            <th>
              <div className="th-data">Detalle</div>
            </th>
            <th>
              <div className="th-data">Alerta</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {ventas?.detalle.map((material, key) =>
            <>
              <tr key={`${material.material}-${material.tipo_material}-vp`}>
                <td>{material.material}</td>
                <td>
                  Venta Propia
                </td>
                <td>
                  {getAlertIconVentas(material.venta_propia_alerta)}
                  <a className="show-mobile-details">
                    <img src={chevronRight} onClick={() => showDetalle(material)} />
                  </a>
                </td>
              </tr>
              <tr key={`${material.material}-${material.tipo_material}-pc`}>
                <td>{material.material}</td>
                <td>
                  Producto Copec
                </td>
                <td>
                  {getAlertIconVentas(material.producto_copec_alerta)}
                  <a className="show-mobile-details">
                    <img src={chevronRight} onClick={() => showDetalle(material)} />
                  </a>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
      {editingMaterial &&
        <Modal isOpen={true} onRequestClose={closeModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Ventas</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
            <div className="responsive-modal-subtitle-cc">{editingMaterial.material}</div>
          </div>
          <div className="mobile-filters__main-section">
            <table className="responsive-table separated-th-table">
              <thead>
                <tr>
                  <th>
                    <div className="th-data">Detalle</div>
                  </th>
                  <th>
                    <div className="th-data">Cant. Lts.</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {types.map((type) =>
                  <tr key={`type-${type.key}`}>
                    <td>
                      {type.label}<br />
                      Venta Propia<br />
                      Producto Copec<br />
                      Total
                    </td>
                    <td className="normal-weight align-right">
                      <br />
                      {getLocaleStringNumber(Math.round(editingMaterial.venta_propia[selector][type.key]))}<br />
                      {getLocaleStringNumber(Math.round(editingMaterial.producto_copec[selector][type.key]))}<br />
                      <div className="pill">{getLocaleStringNumber(Math.round(editingMaterial.total[selector][type.key]))}</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              Cerrar
            </button>
          </div>
        </Modal>
      }
    </div>
  )
}
